import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Header } from '../../components/Header';
import { Load } from '../../components/Load';
import { Sidebar } from '../../components/Sidebar';
import { Main } from '../../components/Main';
import { Form, Button, Col, Row } from 'react-bootstrap';
import { FormGroup } from '../../components/FormGroup';
import { Label } from '../../components/Label';
import InputMask from 'react-input-mask';
import AlertMessage from '../../components/Alert';
import { Options, Select } from '../../components/Select';
import eyeOpen from '../../img/icon/Olho.svg'
import eyeClose from '../../img/icon/Olho Fechado.svg';

import api from '../../services/api';
import './style.css';

import MultiCheckBox, { OptionType, OnSelectFunction } from '../../components/MultiCheckBox';
import { useNavigate, useParams } from 'react-router-dom';

export function CredenciadosEditar() {

    const { id } = useParams();

    const [isLoading, setIsLoading] = useState(false);

    // Informações Gerais
    const [nome, setNome] = useState("");
    const [descricao, setDescricao] = useState("");
    const [duracao, setDuracao] = useState(null);
    const [preco, setPreco] = useState(null);
    const [itens, setItens] = useState<OptionType[]>([]);
    const [selectedItens, setSelectedItens] = useState<string[]>([]);
    const [tipoProduto, setTipoProduto] = useState('Produto');
    const tipos = ['Produto', 'Adicional'];

    // Informações de Funções
    const [quantidadeFuncao, setQuantidadeFuncao] = useState(null);

    const [alert, setAlert] = useState({ show: false, message: '', variant: 'success' });

    const [email, setEmail] = useState("");
    const [chavePix, setChavePix] = useState('');
    const [documento, setDocumento] = useState("");
    const [porcentagem, setPorcentagem] = useState(0);
    const [usuarioId, setUsuarioId] = useState('');

    const navigate = useNavigate();

    useEffect(() => {
        if (id) {
            handleSearchAccredited();
        }
    }, [id]);


    const handleSubmit = async (event: any) => {
        event.preventDefault();
        let isValid = true;
        if (!nome) {
            setAlert({ message: 'Por favor, preencha o campo Nome', variant: 'danger', show: true });
            isValid = false;
            return
        }
        if (!email) {
            setAlert({ message: 'Por favor, preencha o campo E-mail.', variant: 'danger', show: true });
            isValid = false;
            return
        }
        if (!documento) {
            setAlert({ message: 'Por favor, preencha o campo Documento!', variant: 'danger', show: true });
            isValid = false;
            return
        }
        if (!chavePix) {
            setAlert({ message: 'Por favor, preencha o campo Chave Pix.', variant: 'danger', show: true });
            isValid = false;
            return
        }

        if (isValid) {
            try {
                setIsLoading(true)
                const payload = {
                    nome: nome,
                    email: email,
                    documento: documento,
                    chave_pix: chavePix,
                    porcentagem_comissao: porcentagem,
                    usuario_id: usuarioId
                };
                const response = await api.post(`editar-credenciado/${id}`, payload);

                if (response.data === 'Email já utilizado!') {
                    setAlert({ message: 'E-MAIL já cadastrado!', variant: 'danger', show: true });
                    setIsLoading(false)
                    return;
                }

                if (response.status == 200) {
                    setIsLoading(false)
                    setNome('');
                    setEmail('')
                    setDocumento('');
                    setPorcentagem(0);
                    setAlert({ message: 'Credenciado editado com sucesso!', variant: 'success', show: true });
                    setTimeout(() => {
                        navigate('/credenciados');
                    }, 1000); 
                }
            } catch (error) {
                console.error('Erro ao enviar dados do formulário:', error);
                setAlert({ message: 'Erro ao enviar dados do formulário', variant: 'danger', show: true });
                setIsLoading(false)
            } finally {
                setIsLoading(false)
            }
        }
    };

    const handleSearchAccredited = async () => {
        try {
            const response = await api.post(`listar-credenciado-id/${id}`);
            const responseData = response.data;

            setNome(responseData.credenciado.nome);
            setUsuarioId(responseData.credenciado.usuario_id);
            setEmail(responseData.usuario.email);
            setDocumento(responseData.credenciado.documento);
            setChavePix(responseData.credenciado.chave_pix);
            setPorcentagem(responseData.credenciado.porcentagem_comissao);

        } catch (error) {
            console.log(error)
        }
    }

    return (
        <div>
            <Load isLoading={isLoading} />
            <Sidebar />
            <Header route='../../' />
            <Main>
                <Form onSubmit={handleSubmit}>
                    <h3>Editar Credenciado</h3>
                    <Row>
                        <Col xs={12} md={3} xl={3}>
                            <FormGroup>
                                <Label title='Nome do Credenciado' htmlFor="senha" />
                                <input
                                    type="text"
                                    id="nome"
                                    placeholder="Digite o Nome do Credenciado"
                                    value={nome}
                                    onChange={(e) => setNome(e.target.value)}
                                    style={{ width: '100%' }}
                                />
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={3} xl={3}>
                            <FormGroup>
                                <Label title='E-mail do Credenciado' htmlFor="senha" />
                                <input
                                    type="text"
                                    id="email"
                                    placeholder="Digite o e-mail do Credenciado"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    style={{ width: '100%' }}
                                />
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={3} xl={3}>
                            <FormGroup>
                                <Label title='Documento do Credenciado' htmlFor="senha" />
                                <InputMask
                                    type="text"
                                    id="cpf_cnpj"
                                    placeholder="Digite o CNPJ ou CPF do Credenciado"
                                    value={documento}
                                    onChange={(e: any) => setDocumento(e.target.value)}
                                    style={{ width: '100%' }}
                                />
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={3} xl={3}>
                            <FormGroup>
                                <Label title='Chave PIX' htmlFor="senha" />
                                <InputMask
                                    type="text"
                                    id="cpf_cnpj"
                                    placeholder="Digite a chave PIX"
                                    value={chavePix}
                                    onChange={(e: any) => setChavePix(e.target.value)}
                                    style={{ width: '100%' }}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
                        <Button type="submit" style={{ width: '10%' }} className="saveButton" onClick={handleSubmit}>Salvar</Button>
                    </Row>

                </Form>
            </Main>
            <AlertMessage
                show={alert.show}
                message={alert.message}
                variant={alert.variant}
                onClose={() => setAlert({ ...alert, show: false })}
            />
        </div>
    );
}
